module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/babel-runtime/core-js/object/get-prototype-of.js
 ** module id = 6
 ** module chunks = 0
 **/